import {WidgetEventStruct} from '../../widget-event.struct';
import {ModalWidgetEnum, UserWidgetEnum} from '../../../enums';

export class UserWidgetEventStruct extends WidgetEventStruct {
  public event_user_widget_type: UserWidgetEnum;
} // end Package
